import { Action } from '@ngrx/store';
import { PaymentConfiguration } from './../../models/payment-configuration';

export enum PaymentConfigurationActionTypes {
    CLEAR_PAYMENT_CONFIGURATION = '[PAYMENTS] Clear Payment Configuration',
    LOAD_PAYMENT_CONFIGURATION = '[PAYMENTS] Load Payment Configuration',
    ADD_PAYMENT_CONFIGURATION = '[PAYMENTS] Add Payment Configuration'
}

export namespace PaymentConfigurationActions {

    export class ClearPaymentConfiguration implements Action {
        readonly type = PaymentConfigurationActionTypes.CLEAR_PAYMENT_CONFIGURATION;
    }

    export class LoadPaymentConfiguration implements Action {
        readonly type = PaymentConfigurationActionTypes.LOAD_PAYMENT_CONFIGURATION;
    }

    export class AddPaymentConfiguration implements Action {
        readonly type = PaymentConfigurationActionTypes.ADD_PAYMENT_CONFIGURATION;

        constructor(public payload: PaymentConfiguration) {}
    }

}

export type PaymentConfigurationActions =
    | PaymentConfigurationActions.ClearPaymentConfiguration
    | PaymentConfigurationActions.LoadPaymentConfiguration
    | PaymentConfigurationActions.AddPaymentConfiguration;
